import {
    Column,
    Entity,
    Index,
    OneToMany,
    PrimaryGeneratedColumn
} from "typeorm";
import {ProjectProfileSelection} from "./ProjectProfileSelection";
import {SCHEMA_CODE} from "../../project_schemas";

@Index("project_profile_group_pkey", ["id"], { unique: true })
@Entity("project_profile_group")
export class ProjectProfileGroup {
  @PrimaryGeneratedColumn({ type: "bigint", name: "id" })
  id!: number;

  @Column("text", { name: "project_schema_code" })
  projectSchemaCode!: string;

  @OneToMany(
      () => ProjectProfileSelection,
      profileSelection => profileSelection.profileGroup,
  )
  profileSelections!: ProjectProfileSelection[];

}
